<template>
  <el-container>
    <!-- style="height:100%" -->
    <!-- <aside-menu :is-collapse="hideMenu" :menus="menus"></aside-menu> -->
    <el-container direction="vertical">
      <header-top></header-top>
      <el-main class="main-content">
        <router-view v-if="isRouterAlive"></router-view>
      </el-main>
      <!-- <el-footer height="30px">
        ©️2019-2020
      </el-footer> -->
    </el-container>
  </el-container>
</template>
<script>
  import headerTop from '../components/headerTop'
  export default {
    provide() {
      return {
        reload: this.reload
      }
    },

    data() {
      return {
        isRouterAlive: true
      }
    },
    created() {

    },
    components: {
      headerTop
    },
    computed: {

    },
    methods: {
      reload() {
        console.log(33333)
        this.isRouterAlive = false
        this.$nextTick(() => (this.isRouterAlive = true))
      }
    },
    watch: {

    }
  }

</script>
<style lang="less">
  .el-main,
  .el-footer {
    background-color: #fff;
    padding: 0;
    // min-width: 1070px;
    padding: 0 !important;
    overflow: hidden;
    z-index: 99;
    height: 100%;
  }

  .el-header {
    padding: 0 !important
  }

  .el-footer {
    margin: 0;
    color: rgba(0, 0, 0, 0.25);
    font-size: 12px;
    line-height: 14px;
    padding: 8px 16px;
    background-color: #f1f2f5;
  }

  .el-container {
    height: 100%;
    min-height: 768px;
  }

  // .main-content>div {
  //   height: 100%;
  //   position: relative;
  // }

  .el-container.is-vertical {
    // position: fixed !important;
    // top: 0;
    // bottom: 0;
    // position: relative;
    // right: 0;
  }

  .el-menu--collapse+.el-container.is-vertical {
    left: 64px;

  }

  .type1 {
    left: 0px;
  }

  .type2 {
    left: 180px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/manage.vue